<template>
	<div class="p-6 flex flex-col">
		<h2 class="text-3xl font-bold text-gray-900 mb-4">
			{{ __("Welcome") }}
			{{ user.name }},
			{{ __("glad you are here!") }}
		</h2>

		<div v-if="locale == 'de'" class="contents">
			<p class="mb-4">
				Machen Sie jetzt Ihr Kauf- und Verkaufsinteresse auf der Karte sichtbar
				und erweitern Sie Ihren Aktionsradius.
			</p>
			<ul class="list-disc pl-4 mb-4">
				<li>Matching-Algorithmus nutzen</li>
				<li>Sammelgebotsfunktion aktvieren</li>
				<li>Interaktion der Nutzer erhöhen</li>
			</ul>
		</div>

		<div v-else class="contents">
			<p class="mb-4">
				Make your buy and sell interests visibile on the map and expand your
				radius of action!
			</p>
			<ul class="list-disc pl-4 mb-4">
				<li>Use the matching algorithm</li>
				<li>Place bulk bids</li>
				<li>Increase interaction with new business partners</li>
			</ul>
		</div>

	</div>
</template>

<script>
export default {
	props: {
		user: {
			type: Object,
			required: true,
		},
	},
};
</script>
